<template>
    <b-card header="Create New Plan Template" id="create-template" class="flex">
        <b-row class="justify-content-md-center">
            <b-col md="12" xl="12">
                <b-card id="rate-plan-name" header="Plan Name" :class="[planNameError != '' ? 'validation-false' : '', planNamePassed ? 'validation-true' : '']">
                    <b-form-group>
                        <b-form-input type="text" placeholder="Enter plan name" id="pname" name="pname" v-model="template.planName"></b-form-input>
                    </b-form-group>
                    <div v-if="planNameError != ''" class="error-box">{{planNameError}}</div>
                </b-card>

                <b-card id="rate-plan-category" header="Plan Selection" :class="[selectedPlanPassed ? 'validation-true' : '', planCategoryError != '' ? 'validation-false' : '']">
                    <div class="wrapper-plan">
                        <div :class="['plan', 'plan-flex', selectedPlan == 1 ? 'active' : '']" data-plan="Flex" data-plan-id="1" v-on:click="selectPlan(1)">
                            <div class="innerplan">
                                <h3>Flex</h3>
                                <span class="desc">Simple flexible IoT Data</span>
                            </div>
                        </div>

                        <div v-if="nbIoTAvailable" :class="['plan', 'plan-nb', selectedPlan == 5 ? 'active' : '']" data-plan="NB-IoT" data-plan-id="5" v-on:click="selectPlan(5)">
                            <div class="innerplan">
                                <h3>NB-IoT</h3>
                                <span class="desc">NarrowBand IoT</span>
                            </div>
                        </div>

                        <div v-if="catM1Available" :class="['plan', 'cat-m1', selectedPlan == 8 ? 'active' : '']" data-plan="CAT-M1" data-plan-id="8" v-on:click="selectPlan(8)">
                            <div class="innerplan">
                                <h3>Cat-M1</h3>
                                <span class="desc">Cat-M1</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="planCategoryError != ''" class="error-box">{{planCategoryError}}</div>
                </b-card>

                <b-card id="rate-plan-description" header="Plan Description" :class="[planDescriptionError != '' ? 'validation-false' : '', planDescriptionPassed ? 'validation-true' : '']">
                    <b-form-group>
                        <b-form-input type="text" placeholder="Describe the plan you are creating to fit it's usage best" id="pdesc" name="pdesc" v-model="template.planDescription"></b-form-input>
                    </b-form-group>
                    <div v-if="planDescriptionError != ''" class="error-box">{{planDescriptionError}}</div>
                </b-card>

                <b-card id="rate-plan-dataLimit" header="Data Tier" :class="[dataLimitPassed ? 'validation-true' : '', planDataLimitError != '' ? 'validation-false' : '']">
                    <div class="wrapper-switches data-limit">
                        <button v-on:click="selectDataLimit(0, 0)" data-limit="0MB" data-limit-id="0" data-limit-value='0' :class="['button-data', 'flex-data', template.dataLimitId == 0 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">No Data</button>
                        <button v-on:click="selectDataLimit(1, 1)" data-limit="1MB" data-limit-id="1" data-limit-value='1' :class="['button-data', 'flex-data', 'nb-data', template.dataLimitId == 1 ? 'active' : '']">1mb</button>
                        <button v-on:click="selectDataLimit(2, 2)" data-limit="2MB" data-limit-id="2" data-limit-value='2' :class="['button-data', 'flex-data', 'nb-data', template.dataLimitId == 2 ? 'active' : '']">2mb</button>
                        <button v-on:click="selectDataLimit(4, 5)" data-limit="5MB" data-limit-id="4" data-limit-value='5' :class="['button-data', 'flex-data', 'nb-data', template.dataLimitId == 4 ? 'active' : '']">5mb</button>
                        <button v-on:click="selectDataLimit(5, 10)" data-limit="10MB" data-limit-id="5" data-limit-value='10' :class="['button-data', 'flex-data', template.dataLimitId == 5 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">10mb</button>
                        <button v-on:click="selectDataLimit(6, 25)" data-limit="20MB" data-limit-id="6" data-limit-value='25' :class="['button-data', 'flex-data', template.dataLimitId == 6 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">25mb</button>
                        <button v-on:click="selectDataLimit(7, 50)" data-limit="50MB" data-limit-id="7" data-limit-value='50' :class="['button-data', 'flex-data', template.dataLimitId == 7 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">50mb</button>
                        <button v-on:click="selectDataLimit(8, 75)" data-limit="75MB" data-limit-id="8" data-limit-value='75' :class="['button-data', 'flex-data', template.dataLimitId == 8 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">75mb</button>
                        <button v-on:click="selectDataLimit(9, 100)" data-limit="100MB" data-limit-id="9" data-limit-value='100' :class="['button-data', 'flex-data', template.dataLimitId == 9 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">100mb</button>
                        <button v-on:click="selectDataLimit(10, 250)" data-limit="250MB" data-limit-id="10" data-limit-value='250' :class="['button-data', 'flex-data', template.dataLimitId == 10 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">250mb</button>
                        <button v-on:click="selectDataLimit(11, 500)" data-limit="500MB" data-limit-id="11" data-limit-value='500' :class="['button-data', 'flex-data', template.dataLimitId == 11 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">500mb</button>
                        <button v-on:click="selectDataLimit(12, 1024)" data-limit="1GB" data-limit-id="12" data-limit-value='1024' :class="['button-data', 'flex-data', 'hb-data', template.dataLimitId == 12 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">1gb</button>
                        <button v-on:click="selectDataLimit(13, 2048)" data-limit="2GB" data-limit-id="13" data-limit-value='2048' :class="['button-data', 'flex-data', 'hb-data', template.dataLimitId == 13 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">2gb</button>
                        <button v-on:click="selectDataLimit(14, 5120)" data-limit="5GB" data-limit-id="14" data-limit-value='5120' :class="['button-data', 'flex-data', 'hb-data', template.dataLimitId == 14 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">5gb</button>
                        <button v-on:click="selectDataLimit(15, 10240)" data-limit="10GB" data-limit-id="15" data-limit-value='10240' :class="['button-data', 'flex-data', 'hb-data', template.dataLimitId == 15 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">10gb</button>
                        <button v-on:click="selectDataLimit(16, 20480)" data-limit="20GB" data-limit-id="16" data-limit-value='20480' :class="['button-data', 'flex-data', 'hb-data', template.dataLimitId == 16 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">20gb</button>
                        <button v-on:click="selectDataLimit(17, 51200)" data-limit="50GB" data-limit-id="17" data-limit-value='51200' :class="['button-data', 'hb-data', template.dataLimitId == 17 ? 'active' : '', selectedPlan == 5 ? 'hidden' : '']">50gb</button>
                    </div>
                    <div v-if="planDataLimitError != ''" class="error-box">{{planDataLimitError}}</div>
                </b-card>

                <b-card header="Features" class="card-options">
                    <b-row>
                        <b-col v-if="selectedPlan != 5" md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" :disabled="(templateOptions.roaming2 == true ) ? true : false" @change="checkPriceForRatePlan()" v-model="templateOptions.roaming"/>
                            <label>Tier 1 International Roaming</label>
                        </b-col>
                        <b-col v-if="selectedPlan != 5 && tier2Roaming" md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" :disabled="((templateOptions.roaming == true ) ? true : false) || tier2Roaming == false" @change="checkPriceForRatePlan()" v-model="templateOptions.roaming2"/>
                            <label>Tier 2 International Roaming</label>
                        </b-col>
                        <b-col md="6" class="switch-label flex-data hb-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" v-model="templateOptions.sms"/>
                            <label>SMS</label>
                        </b-col>
                        <b-col v-if="selectedPlan != 5" md="6" class="switch-label flex-data hb-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" @change="countRatePlanPrice(lastRatePlanPrice)" v-model="templateOptions.staticip"/>
                            <label>Use Static IP address</label>
                        </b-col>
                        <b-col v-if="selectedPlan == 1" md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" :disabled="voiceAccess == false" @change="checkPriceForRatePlan()" v-model="templateOptions.voice"/>
                            <label>Voice</label>
                        </b-col>
                        <b-col v-if="selectedPlan == 1 && hotSpotAccess" md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="primary" variant="3d" label v-bind="labelIcon" @change="checkPriceForRatePlan()" v-model="templateOptions.hotSpot"/>
                            <label>Hot Spot</label>
                        </b-col>
                    </b-row>
                </b-card>


                <b-card v-if="selectedPlan != 5" id="rate-plan-dataGuard" :class="['data-guard', 'flex-data', 'hb-data', dgoPassed ? 'validation-true' : '', throttleError != '' || capError != '' || alert1Error != '' || alert2Error != '' ? 'validation-false' : '']" no-body>
                    <b-card-header class="header-data-guard">
                        <div>Data Guard</div>
                    </b-card-header>
                    <b-card-body>
                        <b-row class="inner-row">
                            <b-col :class="['dgo-box', 'throttle-box', dataGuard.throttle.status ? 'active' : '', throttleError != '' ? 'error' : '']">
                                <div class="data-innerbox">
                                    <div class="header">
                                        <h3>Throttle</h3>

                                        <div class="popup-tooltip">
                                            <i class="icon-info"></i>
                                            <div class="popup-tooltip-content">
                                                <h3>Throttle</h3>
                                                <p>Slow down data speed after you've reached a certain amount of data usage. Unlike a data cap, which disables any further data usage, throttling simply reduces the upload/download speed.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="inner">
                                        <div class="row-throttle">
                                            <div class="switch-box">
                                                <span class="label">Threshold</span>
                                                <c-switch class="mx-1" id="throttle-switch" color="primary" variant="3d" label v-bind="labelIcon" v-model="dataGuard.throttle.status"/>
                                            </div>
                                            <div class="value">
                                                <b-form-input id="throttle-mb" :type="`number`" :min="1" :max="100000" @keyup.native="checkValueThrottle()" v-model="dataGuard.throttle.data" :disabled="!dataGuard.throttle.status"></b-form-input>
                                                <b-form-select v-model="dataGuard.throttle.dataUnit" class="form-control" id="throttle-unit" :disabled="!dataGuard.throttle.status" :options="dataThrottle"></b-form-select>
                                            </div>
                                        </div>

                                        <div class="row-speed">
                                            <span class="label">Speed</span>
                                            <div class="value">
                                                <b-form-select class="form-control" id="speed-kbs" v-model="dataGuard.throttle.speed" :options="speedGuard" :disabled="!dataGuard.throttle.status"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="throttleError != ''" class="error-box">{{throttleError}}</div>
                            </b-col>

                            <b-col :class="['dgo-box', 'cap-box', dataGuard.cap.status ? 'active' : '', capError != '' ? 'error' : '']">
                                <div class="data-innerbox">
                                    <div class="header">
                                        <h3>Cap</h3>

                                        <div class="popup-tooltip">
                                            <i class="icon-info"></i>
                                            <div class="popup-tooltip-content">
                                                <h3>Cap</h3>
                                                <p>Disable any additional data usage after you’ve reached a certain limit. This safeguards you from using more data than your plan allows.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="inner">
                                        <div class="row-throttle">
                                            <div class="switch-box">
                                                <span class="label">Threshold</span>
                                                <c-switch class="mx-1" id="cap-switch" color="primary" variant="3d" label v-bind="labelIcon" v-model="dataGuard.cap.status"/>
                                            </div>
                                            <div class="value">
                                                <b-form-input :type="`number`" :min="1" :max="100000"  id="cap-mb" @keyup.native="checkValueCap()" min="0" v-model="dataGuard.cap.data" :disabled="!dataGuard.cap.status" ></b-form-input>
                                                <b-form-select v-model="dataGuard.cap.dataUnit" :options="dataThrottle" class="form-control" id="cap-unit" :disabled="!dataGuard.cap.status"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="capError != ''" class="error-box">{{capError}}</div>
                            </b-col>
                            <b-col :class="['dgo-box', 'alert1-box', firstAlert ? 'active' : '', alert1Error != '' ? 'error' : '']">
                                <div class="data-innerbox">
                                    <div class="header">
                                        <h3>Data Guard Alert 1</h3>

                                        <div class="popup-tooltip">
                                            <i class="icon-info"></i>
                                            <div class="popup-tooltip-content">
                                                <h3>Data Guard Alert</h3>
                                                <p>Data Guard Alerts are triggered when the SIM data usage exceeds the set value.</p>
                                                <p>To receive SMS or E-Mail Alert Notifications, they need to be turned on for individual users in Settings/User.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="inner">
                                        <div class="row-throttle">
                                            <div class="switch-box">
                                                <span class="label">Threshold</span>
                                                <c-switch class="mx-1" id="first-alert-switch" color="primary" variant="3d" label v-bind="labelIcon" v-model="firstAlert"/>
                                            </div>
                                            <div class="value">
                                                <b-form-input :type="`number`" :min="1" :max="100000"  id="first-alert-mb" @keyup.native="checkValueFirstAlert()" min="0" v-model="dataGuard.firstUsageAlert.alertAt" :disabled="!firstAlert" ></b-form-input>
                                                <b-form-select v-model="dataGuard.firstUsageAlert.unit" :options="dataThrottle" class="form-control" id="cap-unit" :disabled="!firstAlert"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="alert1Error != ''" class="error-box">{{alert1Error}}</div>
                            </b-col>
                            <b-col :class="['dgo-box', 'alert2-box', secondAlert ? 'active' : '', alert2Error != '' ? 'error' : '']">
                                <div class="data-innerbox">
                                    <div class="header">
                                        <h3>Data Guard Alert 2</h3>

                                        <div class="popup-tooltip">
                                            <i class="icon-info"></i>
                                            <div class="popup-tooltip-content">
                                                <h3>Data Guard Alert</h3>
                                                <p>Data Guard Alerts are triggered when the SIM data usage exceeds the set value.</p>
                                                <p>To receive SMS or E-Mail Alert Notifications, they need to be turned on for individual users in Settings/User.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="inner">
                                        <div class="row-throttle">
                                            <div class="switch-box">
                                                <span class="label">Threshold</span>
                                                <c-switch class="mx-1" id="second-alert-switch" color="primary" variant="3d" label v-bind="labelIcon" v-model="secondAlert"/>
                                            </div>
                                            <div class="value">
                                                <b-form-input :type="`number`" :min="1" :max="100000"  id="second-alert-mb" @keyup.native="checkValueSecondAlert()" min="0" v-model="dataGuard.secondUsageAlert.alertAt" :disabled="!secondAlert" ></b-form-input>
                                                <b-form-select v-model="dataGuard.secondUsageAlert.unit" :options="dataThrottle" class="form-control" id="cap-unit" :disabled="!secondAlert"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="alert2Error != ''" class="error-box">{{alert2Error}}</div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card class="button-wrap text-right create-plan-summary">
                    <div class="price-wrapper">
                        <div class="start-price">
                            <span>Monthly Charge</span>
                            <em>{{summaryPrice.showStartPrice}} USD</em>
                        </div>
                        <div v-if="templateOptions.staticip" class="static-ip">
                            <span>Static IP</span>
                            <em>{{summaryPrice.staticIpCharge}} USD</em>
                        </div>

                        <div v-if="summaryPrice.userDiscount > 0" class="user-discount">
                            <span>User Discount</span>
                            <em>{{summaryPrice.userDiscount*100}} %</em>
                        </div>
                        <div class="final-price">
                            <span>Final Price <small>TAX included.</small></span>
                            <em>{{summaryPrice.finalPrice}} USD</em>
                        </div>
                        <div class="overage-price">
                            <span>( Final Pricing does not include the SMS Usage & Data Overage rates )</span>

                            <div class="price-wrapper">
                                <div v-if="templateOptions.sms" class="overage-price">
                                    <span>SMS Price</span>
                                    <em>{{summaryPrice.smsCharge}} USD</em>
                                </div>
                                <div class="overage-price">
                                    <span>Overage</span>
                                    <em>{{summaryPrice.ovarage}} USD</em>
                                </div>
                                <div class="overage-price">
                                    <span>Suspend Rate</span>
                                    <em>{{summaryPrice.suspensionCharge}} USD</em>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>

                <b-card class="button-wrap text-right create-plan-summary">
                    <router-link to="/settings/plans/">
                        <b-button variant="light">Cancel</b-button>
                    </router-link>
                    <b-button v-on:click="createPlan" variant="success">Create Rate Plan</b-button>
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="add-credit-card" size="md" class="user-settings" centered title="Add Credit Card" ref="add-credit-card" hide-footer centered>
            <div class="required-cc">
                <b-row>
                    <b-col md="12">
                        <h3>Please add a payment method to continue.</h3>
                    </b-col>
                </b-row>
            </div>
            <div class="user-details">
                <b-row>
                    <b-col md="12">
                        <b-form-group>
                            <label for="cname">Card Nickname</label>
                            <b-form-input type="text" id="cname" v-model="newCard.cardNick" placeholder="Work" v-validate="'required'" data-vv-as="card nick" name="cname"></b-form-input>
                            <span v-show="errors && errors.has('cname')" class="validate-warning">{{ errors.first('cname') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <div id="card" ref="card"></div>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label>Billing Address</label>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="address">Address</label>
                            <b-form-input
                                type="text"
                                id="address"
                                placeholder="ex. 23 High St, Apt 5"
                                v-model="newCard.customer.address"
                                v-validate="'required'"
                                name="address"
                            ></b-form-input>
                            <span v-show="errors && errors.has('address')" class="validate-warning">{{ errors.first('address') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="city">City</label>
                            <b-form-input type="text" id="city" placeholder="ex. New York" v-model="newCard.customer.city" v-validate="'required'" name="city"></b-form-input>
                            <span v-show="errors && errors.has('city')" class="validate-warning">{{ errors.first('city') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group :class="['no-mt', errors && errors.has('state-user') ? 'error-field' : '']" v-if="country == 'United States'">
                            <label for="state-user">State</label>
                            <select class="form-control" name="state-user" v-model="newCard.customer.state" v-validate="'required'" data-vv-as="state">
                                <option v-for="state in stateList" v-bind:key="state.abbreviation" :value="state.abbreviation">{{ state.name }}</option>
                            </select>
                            <span v-show="errors && errors.has('state-user')" class="validate-warning">{{ errors.first('state-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group v-if="country == 'United States'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true, regex: /^[0-9]{5}(-[0-9]{4})?$/}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>

                        <b-form-group v-if="country == 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true, regex: /^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}$/}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>

                        <b-form-group v-if="country != 'United States' && country != 'Canada'" :class="[errors && errors.has('pcode-user') ? 'error-field' : '']">
                            <label for="pcode-user">Postal Code</label>
                            <input type="text" class="form-control" name="pcode-user" v-model="newCard.customer.zip" v-validate="{required: true}" data-vv-as="postal code">
                            <span v-show="errors && errors.has('pcode-user')" class="validate-warning">{{ errors.first('pcode-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group :class="['no-mt', errors && errors.has('contries-user') ? 'error-field' : '']">
                            <label for="country-user">Country</label>
                            <select class="form-control" name="contries-user" v-model="country" v-validate="'required'" data-vv-as="country">
                                <option v-for="country in countries" v-bind:key="country.name" :name="country.name">{{ country.name }}</option>
                            </select>
                            <span v-show="errors && errors.has('contries-user')" class="validate-warning">{{ errors.first('contries-user') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group class="switch-inline-label">
                            <div>
                                <c-switch
                                        class="mx-1"
                                        color="success"
                                        defaultChecked
                                        variant="3d"
                                        label
                                        v-bind="labelIcon"
                                        v-model="newCard.default"
                                />
                                <label>Set As Default Payment Method</label>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <footer id="add-credit-card___BV_modal_footer_" class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="$bvModal.hide('add-credit-card')">Cancel</button>
                <button type="button" class="btn btn-primary action-element" :disabled="blockAddButton" @click="addCreditCard">OK</button>
            </footer>
        </b-modal>
    </b-card>
</template>

<script>
import Vue from "vue";
import globalStore from "../../variables";
import { Switch as cSwitch } from "@coreui/vue";
import Axios from "axios";
import VeeValidate from "vee-validate";
import { setTimeout } from 'timers';
import FTScheckbox from "../../ftsComponents/FTScheckbox";
import {loadStripe} from '@stripe/stripe-js';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

const veeValidateConfig = {};

Vue.use(VeeValidate, veeValidateConfig);

export default {
    name: "Plans",
    components: {
        FTScheckbox,
        cSwitch
    },
    data: () => {
        return {
            lastRatePlanPrice: {
                basePrice: 0,
                companyDiscount: 0,
                custom: 0,
                discountedBasePrice: 0,
                discountedRatePerOverageMb: 0,
                ratePerOverageMb: 0,
                smsCharge: 0,
                staticIpCharge: 0,
                suspensionCharge: 0,
            },
            selectedPlan: 0,
            speedGuard: [
                { value: 0, text: 'Select throttle speed' },
                { value: 1, text: '64 Kbps' },
                { value: 2, text: '128 Kbps' },
                { value: 3, text: '256 Kbps' },
                { value: 4, text: '512 Kbps' },
                { value: 5, text: '768 Kbps' },
                { value: 7, text: '1 Mbps' },
                { value: 8, text: '25 Mbps' }
            ],
            validate: {
                planSelection: false,
                dataLimit: false
            },
            items: [
                {
                    size: "Large",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "lg",
                        checked: true
                    },
                    size_prop: 'Add following prop <code>size="lg"</code>'
                },
                {
                    size: "Normal",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "",
                        checked: true
                    },
                    size_prop: "-"
                },
                {
                    size: "Small",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "sm",
                        checked: true
                    },
                    size_prop: 'Add following prop <code>size="sm"</code>'
                }
            ],
            checker: "yes",
            picker: "",
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },
            labelTxt: {
                dataOn: "yes",
                dataOff: "no"
            },
            template: {
                planName: null,
                planDescription: null,
                planCategoryId: 0,
                dataLimitId: 5,
                planOptionIds: [],
                dataGuard: {
                    hasThrottle: 0,
                    hasCap: 0,
                    throttleAt: 0,
                    throttleAtUnit: "",
                    throttleSpeedId: 0,
                    capAt: 0,
                    capAtUnit: ""
                }
            },
            templateOptions: {
                roaming: false,
                roaming2: false,
                pooling: false,
                sms: false,
                staticip: false,
                hotSpot: false,
                voice: false
            },
            templateOptionsArr: [],
            firstAlert: false,
            secondAlert: false,
            dataGuard: {
                throttle: {
                    status: false,
                    data: null,
                    dataUnit: "MB",
                    speed: 0,
                    speedUnit: ""
                },
                cap: {
                    status: false,
                    data: null,
                    dataUnit: "MB"
                },
                firstUsageAlert: {
                    alertAt: null,
                    unit: "MB"
                },
                secondUsageAlert: {
                    alertAt: null,
                    unit: "MB"
                },
            },
            speedThrottle: ["MB/s", "GB/s"],
            dataThrottle: ["MB", "GB"],
            selectedThrottle: "",
            selectedSpeed: "",
            selectedCap: "",
            addErrors: {
                name: [],
                category: [],
                description: [],
                dataLimit: [],
                options: [],
                dataGuard: [],
                other: []
            },
            usageAlertsAvailable: false,
            usageAlerts: {
                alertAt: null,
                unit: 'MB',
                additionalNotifications: {
                    sms: false,
                    email: false
                }
            },
            usageAlertValidationError: false,
            priceRatePlan: {
                dataLimit: '10',
                roaming: false
            },
            summaryPrice: {
                showStartPrice: 0,
                startPrice: 0,
                userDiscount: '0%',
                finalPrice: 0,
                custom: false,
                discountedRatePerOverageMb: 0,
                smsCharge: 0,
                suspensionCharge: 0,
            },
            planNameError: '',
            planNamePassed: false,
            selectedPlanPassed: false,
            planCategoryError: '',
            planDescriptionError: '',
            planDescriptionPassed: false,
            planDataLimitError: '',
            dataLimitPassed: false,
            dgoPassed: false,
            throttleError: '',
            capError: '',
            alert1Error: '',
            alert2Error: '',
            prePaidAccount: false,
            noCreditCards: false,
            newCard: {
                cardNick: '',
                cardToken: null,
                default: false,
                customer: {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                }
            },
            card: undefined,
            stripe: undefined,
            elements: undefined,
            optionsCard: undefined,
            nbIoTAvailable: false,
            catM1Available: false,
            stateList: [
                {
                    "name": "Alabama",
                    "abbreviation": "AL"
                },
                {
                    "name": "Alaska",
                    "abbreviation": "AK"
                },
                {
                    "name": "American Samoa",
                    "abbreviation": "AS"
                },
                {
                    "name": "Arizona",
                    "abbreviation": "AZ"
                },
                {
                    "name": "Arkansas",
                    "abbreviation": "AR"
                },
                {
                    "name": "California",
                    "abbreviation": "CA"
                },
                {
                    "name": "Colorado",
                    "abbreviation": "CO"
                },
                {
                    "name": "Connecticut",
                    "abbreviation": "CT"
                },
                {
                    "name": "Delaware",
                    "abbreviation": "DE"
                },
                {
                    "name": "District Of Columbia",
                    "abbreviation": "DC"
                },
                {
                    "name": "Federated States Of Micronesia",
                    "abbreviation": "FM"
                },
                {
                    "name": "Florida",
                    "abbreviation": "FL"
                },
                {
                    "name": "Georgia",
                    "abbreviation": "GA"
                },
                {
                    "name": "Guam",
                    "abbreviation": "GU"
                },
                {
                    "name": "Hawaii",
                    "abbreviation": "HI"
                },
                {
                    "name": "Idaho",
                    "abbreviation": "ID"
                },
                {
                    "name": "Illinois",
                    "abbreviation": "IL"
                },
                {
                    "name": "Indiana",
                    "abbreviation": "IN"
                },
                {
                    "name": "Iowa",
                    "abbreviation": "IA"
                },
                {
                    "name": "Kansas",
                    "abbreviation": "KS"
                },
                {
                    "name": "Kentucky",
                    "abbreviation": "KY"
                },
                {
                    "name": "Louisiana",
                    "abbreviation": "LA"
                },
                {
                    "name": "Maine",
                    "abbreviation": "ME"
                },
                {
                    "name": "Marshall Islands",
                    "abbreviation": "MH"
                },
                {
                    "name": "Maryland",
                    "abbreviation": "MD"
                },
                {
                    "name": "Massachusetts",
                    "abbreviation": "MA"
                },
                {
                    "name": "Michigan",
                    "abbreviation": "MI"
                },
                {
                    "name": "Minnesota",
                    "abbreviation": "MN"
                },
                {
                    "name": "Mississippi",
                    "abbreviation": "MS"
                },
                {
                    "name": "Missouri",
                    "abbreviation": "MO"
                },
                {
                    "name": "Montana",
                    "abbreviation": "MT"
                },
                {
                    "name": "Nebraska",
                    "abbreviation": "NE"
                },
                {
                    "name": "Nevada",
                    "abbreviation": "NV"
                },
                {
                    "name": "New Hampshire",
                    "abbreviation": "NH"
                },
                {
                    "name": "New Jersey",
                    "abbreviation": "NJ"
                },
                {
                    "name": "New Mexico",
                    "abbreviation": "NM"
                },
                {
                    "name": "New York",
                    "abbreviation": "NY"
                },
                {
                    "name": "North Carolina",
                    "abbreviation": "NC"
                },
                {
                    "name": "North Dakota",
                    "abbreviation": "ND"
                },
                {
                    "name": "Northern Mariana Islands",
                    "abbreviation": "MP"
                },
                {
                    "name": "Ohio",
                    "abbreviation": "OH"
                },
                {
                    "name": "Oklahoma",
                    "abbreviation": "OK"
                },
                {
                    "name": "Oregon",
                    "abbreviation": "OR"
                },
                {
                    "name": "Palau",
                    "abbreviation": "PW"
                },
                {
                    "name": "Pennsylvania",
                    "abbreviation": "PA"
                },
                {
                    "name": "Puerto Rico",
                    "abbreviation": "PR"
                },
                {
                    "name": "Rhode Island",
                    "abbreviation": "RI"
                },
                {
                    "name": "South Carolina",
                    "abbreviation": "SC"
                },
                {
                    "name": "South Dakota",
                    "abbreviation": "SD"
                },
                {
                    "name": "Tennessee",
                    "abbreviation": "TN"
                },
                {
                    "name": "Texas",
                    "abbreviation": "TX"
                },
                {
                    "name": "Utah",
                    "abbreviation": "UT"
                },
                {
                    "name": "Vermont",
                    "abbreviation": "VT"
                },
                {
                    "name": "Virgin Islands",
                    "abbreviation": "VI"
                },
                {
                    "name": "Virginia",
                    "abbreviation": "VA"
                },
                {
                    "name": "Washington",
                    "abbreviation": "WA"
                },
                {
                    "name": "West Virginia",
                    "abbreviation": "WV"
                },
                {
                    "name": "Wisconsin",
                    "abbreviation": "WI"
                },
                {
                    "name": "Wyoming",
                    "abbreviation": "WY"
                }
            ],
            countries: [
                {"name": "United States", "code": "US"},
                {"name": "Afghanistan", "code": "AF"},
                {"name": "Åland Islands", "code": "AX"},
                {"name": "Albania", "code": "AL"},
                {"name": "Algeria", "code": "DZ"},
                {"name": "American Samoa", "code": "AS"},
                {"name": "AndorrA", "code": "AD"},
                {"name": "Angola", "code": "AO"},
                {"name": "Anguilla", "code": "AI"},
                {"name": "Antarctica", "code": "AQ"},
                {"name": "Antigua and Barbuda", "code": "AG"},
                {"name": "Argentina", "code": "AR"},
                {"name": "Armenia", "code": "AM"},
                {"name": "Aruba", "code": "AW"},
                {"name": "Australia", "code": "AU"},
                {"name": "Austria", "code": "AT"},
                {"name": "Azerbaijan", "code": "AZ"},
                {"name": "Bahamas", "code": "BS"},
                {"name": "Bahrain", "code": "BH"},
                {"name": "Bangladesh", "code": "BD"},
                {"name": "Barbados", "code": "BB"},
                {"name": "Belarus", "code": "BY"},
                {"name": "Belgium", "code": "BE"},
                {"name": "Belize", "code": "BZ"},
                {"name": "Benin", "code": "BJ"},
                {"name": "Bermuda", "code": "BM"},
                {"name": "Bhutan", "code": "BT"},
                {"name": "Bolivia", "code": "BO"},
                {"name": "Bosnia and Herzegovina", "code": "BA"},
                {"name": "Botswana", "code": "BW"},
                {"name": "Bouvet Island", "code": "BV"},
                {"name": "Brazil", "code": "BR"},
                {"name": "British Indian Ocean Territory", "code": "IO"},
                {"name": "Brunei Darussalam", "code": "BN"},
                {"name": "Bulgaria", "code": "BG"},
                {"name": "Burkina Faso", "code": "BF"},
                {"name": "Burundi", "code": "BI"},
                {"name": "Cambodia", "code": "KH"},
                {"name": "Cameroon", "code": "CM"},
                {"name": "Canada", "code": "CA"},
                {"name": "Cape Verde", "code": "CV"},
                {"name": "Cayman Islands", "code": "KY"},
                {"name": "Central African Republic", "code": "CF"},
                {"name": "Chad", "code": "TD"},
                {"name": "Chile", "code": "CL"},
                {"name": "China", "code": "CN"},
                {"name": "Christmas Island", "code": "CX"},
                {"name": "Cocos (Keeling) Islands", "code": "CC"},
                {"name": "Colombia", "code": "CO"},
                {"name": "Comoros", "code": "KM"},
                {"name": "Congo", "code": "CG"},
                {"name": "Congo, The Democratic Republic of the", "code": "CD"},
                {"name": "Cook Islands", "code": "CK"},
                {"name": "Costa Rica", "code": "CR"},
                {"name": "Cote D'Ivoire", "code": "CI"},
                {"name": "Croatia", "code": "HR"},
                {"name": "Cuba", "code": "CU"},
                {"name": "Cyprus", "code": "CY"},
                {"name": "Czechia", "code": "CZ"},
                {"name": "Denmark", "code": "DK"},
                {"name": "Djibouti", "code": "DJ"},
                {"name": "Dominica", "code": "DM"},
                {"name": "Dominican Republic", "code": "DO"},
                {"name": "Ecuador", "code": "EC"},
                {"name": "Egypt", "code": "EG"},
                {"name": "El Salvador", "code": "SV"},
                {"name": "Equatorial Guinea", "code": "GQ"},
                {"name": "Eritrea", "code": "ER"},
                {"name": "Estonia", "code": "EE"},
                {"name": "Ethiopia", "code": "ET"},
                {"name": "Falkland Islands (Malvinas)", "code": "FK"},
                {"name": "Faroe Islands", "code": "FO"},
                {"name": "Fiji", "code": "FJ"},
                {"name": "Finland", "code": "FI"},
                {"name": "France", "code": "FR"},
                {"name": "French Guiana", "code": "GF"},
                {"name": "French Polynesia", "code": "PF"},
                {"name": "French Southern Territories", "code": "TF"},
                {"name": "Gabon", "code": "GA"},
                {"name": "Gambia", "code": "GM"},
                {"name": "Georgia", "code": "GE"},
                {"name": "Germany", "code": "DE"},
                {"name": "Ghana", "code": "GH"},
                {"name": "Gibraltar", "code": "GI"},
                {"name": "Greece", "code": "GR"},
                {"name": "Greenland", "code": "GL"},
                {"name": "Grenada", "code": "GD"},
                {"name": "Guadeloupe", "code": "GP"},
                {"name": "Guam", "code": "GU"},
                {"name": "Guatemala", "code": "GT"},
                {"name": "Guernsey", "code": "GG"},
                {"name": "Guinea", "code": "GN"},
                {"name": "Guinea-Bissau", "code": "GW"},
                {"name": "Guyana", "code": "GY"},
                {"name": "Haiti", "code": "HT"},
                {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
                {"name": "Holy See (Vatican City State)", "code": "VA"},
                {"name": "Honduras", "code": "HN"},
                {"name": "Hong Kong", "code": "HK"},
                {"name": "Hungary", "code": "HU"},
                {"name": "Iceland", "code": "IS"},
                {"name": "India", "code": "IN"},
                {"name": "Indonesia", "code": "ID"},
                {"name": "Iran, Islamic Republic Of", "code": "IR"},
                {"name": "Iraq", "code": "IQ"},
                {"name": "Ireland", "code": "IE"},
                {"name": "Isle of Man", "code": "IM"},
                {"name": "Israel", "code": "IL"},
                {"name": "Italy", "code": "IT"},
                {"name": "Jamaica", "code": "JM"},
                {"name": "Japan", "code": "JP"},
                {"name": "Jersey", "code": "JE"},
                {"name": "Jordan", "code": "JO"},
                {"name": "Kazakhstan", "code": "KZ"},
                {"name": "Kenya", "code": "KE"},
                {"name": "Kiribati", "code": "KI"},
                {"name": "Korea, Democratic People's Republic of", "code": "KP"},
                {"name": "Korea, Republic of", "code": "KR"},
                {"name": "Kuwait", "code": "KW"},
                {"name": "Kyrgyzstan", "code": "KG"},
                {"name": "Lao People'S Democratic Republic", "code": "LA"},
                {"name": "Latvia", "code": "LV"},
                {"name": "Lebanon", "code": "LB"},
                {"name": "Lesotho", "code": "LS"},
                {"name": "Liberia", "code": "LR"},
                {"name": "Libyan Arab Jamahiriya", "code": "LY"},
                {"name": "Liechtenstein", "code": "LI"},
                {"name": "Lithuania", "code": "LT"},
                {"name": "Luxembourg", "code": "LU"},
                {"name": "Macao", "code": "MO"},
                {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
                {"name": "Madagascar", "code": "MG"},
                {"name": "Malawi", "code": "MW"},
                {"name": "Malaysia", "code": "MY"},
                {"name": "Maldives", "code": "MV"},
                {"name": "Mali", "code": "ML"},
                {"name": "Malta", "code": "MT"},
                {"name": "Marshall Islands", "code": "MH"},
                {"name": "Martinique", "code": "MQ"},
                {"name": "Mauritania", "code": "MR"},
                {"name": "Mauritius", "code": "MU"},
                {"name": "Mayotte", "code": "YT"},
                {"name": "Mexico", "code": "MX"},
                {"name": "Micronesia, Federated States of", "code": "FM"},
                {"name": "Moldova, Republic of", "code": "MD"},
                {"name": "Monaco", "code": "MC"},
                {"name": "Mongolia", "code": "MN"},
                {"name": "Montserrat", "code": "MS"},
                {"name": "Morocco", "code": "MA"},
                {"name": "Mozambique", "code": "MZ"},
                {"name": "Myanmar", "code": "MM"},
                {"name": "Namibia", "code": "NA"},
                {"name": "Nauru", "code": "NR"},
                {"name": "Nepal", "code": "NP"},
                {"name": "Netherlands", "code": "NL"},
                {"name": "Netherlands Antilles", "code": "AN"},
                {"name": "New Caledonia", "code": "NC"},
                {"name": "New Zealand", "code": "NZ"},
                {"name": "Nicaragua", "code": "NI"},
                {"name": "Niger", "code": "NE"},
                {"name": "Nigeria", "code": "NG"},
                {"name": "Niue", "code": "NU"},
                {"name": "Norfolk Island", "code": "NF"},
                {"name": "Northern Mariana Islands", "code": "MP"},
                {"name": "Norway", "code": "NO"},
                {"name": "Oman", "code": "OM"},
                {"name": "Pakistan", "code": "PK"},
                {"name": "Palau", "code": "PW"},
                {"name": "Palestinian Territory, Occupied", "code": "PS"},
                {"name": "Panama", "code": "PA"},
                {"name": "Papua New Guinea", "code": "PG"},
                {"name": "Paraguay", "code": "PY"},
                {"name": "Peru", "code": "PE"},
                {"name": "Philippines", "code": "PH"},
                {"name": "Pitcairn", "code": "PN"},
                {"name": "Poland", "code": "PL"},
                {"name": "Portugal", "code": "PT"},
                {"name": "Puerto Rico", "code": "PR"},
                {"name": "Qatar", "code": "QA"},
                {"name": "Reunion", "code": "RE"},
                {"name": "Romania", "code": "RO"},
                {"name": "Russian Federation", "code": "RU"},
                {"name": "RWANDA", "code": "RW"},
                {"name": "Saint Helena", "code": "SH"},
                {"name": "Saint Kitts and Nevis", "code": "KN"},
                {"name": "Saint Lucia", "code": "LC"},
                {"name": "Saint Pierre and Miquelon", "code": "PM"},
                {"name": "Saint Vincent and the Grenadines", "code": "VC"},
                {"name": "Samoa", "code": "WS"},
                {"name": "San Marino", "code": "SM"},
                {"name": "Sao Tome and Principe", "code": "ST"},
                {"name": "Saudi Arabia", "code": "SA"},
                {"name": "Senegal", "code": "SN"},
                {"name": "Serbia and Montenegro", "code": "CS"},
                {"name": "Seychelles", "code": "SC"},
                {"name": "Sierra Leone", "code": "SL"},
                {"name": "Singapore", "code": "SG"},
                {"name": "Slovakia", "code": "SK"},
                {"name": "Slovenia", "code": "SI"},
                {"name": "Solomon Islands", "code": "SB"},
                {"name": "Somalia", "code": "SO"},
                {"name": "South Africa", "code": "ZA"},
                {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
                {"name": "Spain", "code": "ES"},
                {"name": "Sri Lanka", "code": "LK"},
                {"name": "Sudan", "code": "SD"},
                {"name": "Suriname", "code": "SR"},
                {"name": "Svalbard and Jan Mayen", "code": "SJ"},
                {"name": "Swaziland", "code": "SZ"},
                {"name": "Sweden", "code": "SE"},
                {"name": "Switzerland", "code": "CH"},
                {"name": "Syrian Arab Republic", "code": "SY"},
                {"name": "Taiwan, Province of China", "code": "TW"},
                {"name": "Tajikistan", "code": "TJ"},
                {"name": "Tanzania, United Republic of", "code": "TZ"},
                {"name": "Thailand", "code": "TH"},
                {"name": "Timor-Leste", "code": "TL"},
                {"name": "Togo", "code": "TG"},
                {"name": "Tokelau", "code": "TK"},
                {"name": "Tonga", "code": "TO"},
                {"name": "Trinidad and Tobago", "code": "TT"},
                {"name": "Tunisia", "code": "TN"},
                {"name": "Turkey", "code": "TR"},
                {"name": "Turkmenistan", "code": "TM"},
                {"name": "Turks and Caicos Islands", "code": "TC"},
                {"name": "Tuvalu", "code": "TV"},
                {"name": "Uganda", "code": "UG"},
                {"name": "Ukraine", "code": "UA"},
                {"name": "United Arab Emirates", "code": "AE"},
                {"name": "United Kingdom", "code": "GB"},
                {"name": "United States Minor Outlying Islands", "code": "UM"},
                {"name": "Uruguay", "code": "UY"},
                {"name": "Uzbekistan", "code": "UZ"},
                {"name": "Vanuatu", "code": "VU"},
                {"name": "Venezuela", "code": "VE"},
                {"name": "Viet Nam", "code": "VN"},
                {"name": "Virgin Islands, British", "code": "VG"},
                {"name": "Virgin Islands, U.S.", "code": "VI"},
                {"name": "Wallis and Futuna", "code": "WF"},
                {"name": "Western Sahara", "code": "EH"},
                {"name": "Yemen", "code": "YE"},
                {"name": "Zambia", "code": "ZM"},
                {"name": "Zimbabwe", "code": "ZW"}
            ],
            country: 'United States',
            tier2Roaming: false,
            voiceAccess: false,
            hotSpotAccess: false,
            blockAddButton: false
        };
    },
    methods: {
        addCreditCard () {
            this.blockAddButton = true
            let nameCard = this.newCard.cardNick,
                tempThis = this;

            this.stripe.createToken(this.card, {name: nameCard}).then((result) => {
                if (result.error) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Credit Card Error',
                        text: 'Error Validating Credit Card - Contact Support',
                        duration: 5000,
                    });
                    this.blockAddButton = false
                    console.log(result.error)
                    return false;
                }
                tempThis.newCard.cardToken = result.token.id
                tempThis.saveCardInApi();
            });
        },
        async initStripe() {
            let kindTheme = document.querySelector("body").classList.contains('dark-theme') ? true : false;

            if (globalStore.data.runTimeEnviroment != 'portalsimoniot') {
                this.stripe = await loadStripe('pk_test_l3Wo58GDAaNzjOR1YAFq679e000GwfPacx');
            } else {
                this.stripe = await loadStripe('pk_live_68se4hupVyIP7VhdiJCSY0Hw00Cqs6Aifg');
            }
            this.elements = this.stripe.elements();

            if (kindTheme == true) {
                this.optionsCard = {
                    hidePostalCode: true,
                    metadata: {
                        companyId: 1
                    },
                    style: {
                        base: {
                            color: '#fff',
                            '::placeholder': {
                                color: 'rgba(255, 255, 255, .6)'
                            },
                        }
                    }
                }
            } else {
                this.optionsCard = {
                    hidePostalCode: true,
                    metadata: {
                        companyId: 1
                    }
                }
            }

            this.card = this.elements.create("card", this.optionsCard);
        },
        saveCardInApi() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.saveCreditCard()
                }
            })
        },
        saveCreditCard() {
            var tempThis = this;
            Axios.post(globalStore.data.restApiUrl + "/billing/card", this.newCard).then(response => {
                this.noCreditCards = false;
                this.blockAddButton = false
                this.$notify({
                    type: 'success',
                    group: 'notification',
                    title: 'New Credit Card Saved',
                    text: 'New Credit Card was saved successfully. Now you can add new Rate Plan.',
                    duration: 5000,
                });
                this.$refs['add-credit-card'].hide()
            })
            .catch(error => {
                this.blockAddButton = false
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Credit Card error',
                    text: 'Error Adding New Credit Card - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getCreditCards() {
            Axios.get(globalStore.data.restApiUrl + '/account/credit-card')
                .then(response => {
                    if (response.data.length == 0) {
                        this.noCreditCards = true
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error',
                        text: 'Error Retrieving Credit Card Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        checkPriceForRatePlan() {

            let roaming = false

            if (this.templateOptions.roaming == true) {
                roaming = true
            }

            if (this.templateOptions.roaming2 == true) {
                roaming = true
            }

            this.priceRatePlan.roaming = roaming
            Axios.post(`${globalStore.data.restApiUrl}/billing-pricing/base-price`, this.priceRatePlan)
                .then(response => {
                    this.lastRatePlanPrice = response.data;
                    this.countRatePlanPrice(this.lastRatePlanPrice);
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Check Rate Plan Price',
                        text: 'Check Rate Plan Price was error',
                        duration: 5000,
                    });
                })
        },
        countRatePlanPrice(data) {
            this.summaryPrice.showStartPrice = data.basePrice;
            this.summaryPrice.startPrice = (data.companyDiscount > 0) ? data.discountedBasePrice.toFixed(2) : data.basePrice.toFixed(2)
            this.summaryPrice.userDiscount = data.companyDiscount.toFixed(2)
            this.summaryPrice.custom = data.custom
            this.summaryPrice.staticIpCharge = data.staticIpCharge.toFixed(2)
            this.summaryPrice.smsCharge = data.smsCharge.toFixed(2)
            this.summaryPrice.suspensionCharge = data.suspensionCharge.toFixed(2);
            this.summaryPrice.ovarage = (data.companyDiscount > 0) ? data.discountedRatePerOverageMb.toFixed(3) : data.ratePerOverageMb.toFixed(3)
            this.summaryPrice.finalPrice = Number(this.summaryPrice.startPrice);

            if (this.templateOptions.staticip) {
                this.summaryPrice.finalPrice = Number(this.summaryPrice.finalPrice) + Number(this.summaryPrice.staticIpCharge);
            }

            this.summaryPrice.finalPrice = this.summaryPrice.finalPrice.toFixed(2)
        },
        checkValueThrottle() {
            if(this.dataGuard.throttle.data < 0) {
                this.dataGuard.throttle.data = Math.abs(this.dataGuard.throttle.data)
            }
            if (this.dataGuard.throttle.data > 100000 && this.dataGuard.throttle.dataUnit == 'MB') {
                this.dataGuard.throttle.data = 100000;
            }
            this.dataGuard.throttle.data = parseInt(this.dataGuard.throttle.data)
        },
        checkValueCap() {
            if(this.dataGuard.throttle.data < 0) {
                this.dataGuard.cap.data = Math.abs(this.dataGuard.cap.data)
            }
            if (this.dataGuard.cap.data > 100000 && this.dataGuard.cap.dataUnit == 'MB') {
                this.dataGuard.cap.data = 100000;
            }
            this.dataGuard.cap.data = parseInt(this.dataGuard.cap.data)
        },
        checkValueFirstAlert() {
            if(this.dataGuard.firstUsageAlert.alertAt < 0) {
                this.dataGuard.firstUsageAlert.alertAt = Math.abs(this.dataGuard.firstUsageAlert.alertAt)
            }
            if (this.dataGuard.firstUsageAlert.alertAt > 100000 && this.dataGuard.firstUsageAlert.unit == 'MB') {
                this.dataGuard.firstUsageAlert.alertAt = 100000;
            }
            this.dataGuard.firstUsageAlert.alertAt = parseInt(this.dataGuard.firstUsageAlert.alertAt)
        },
        checkValueSecondAlert() {
            if(this.dataGuard.secondUsageAlert.alertAt < 0) {
                this.dataGuard.secondUsageAlert.alertAt = Math.abs(this.dataGuard.secondUsageAlert.alertAt)
            }
            if (this.dataGuard.secondUsageAlert.alertAt > 100000 && this.dataGuard.secondUsageAlert.unit == 'MB') {
                this.dataGuard.secondUsageAlert.alertAt = 100000;
            }
            this.dataGuard.secondUsageAlert.alertAt = parseInt(this.dataGuard.secondUsageAlert.alertAt)
        },
        toggleActive: event => {
            event.preventDefault();
            event.stopPropagation();

            let elem = event.target;
        },
        selectPlan(planId) {
            this.selectedPlan = planId;
            if (planId == 5) {
                this.dataGuard.throttle.status = false
                this.dataGuard.cap.status = false
                this.firstAlert = false
                this.secondAlert = false
                this.templateOptions = {
                    roaming: false,
                    roaming2: false,
                    pooling: false,
                    staticip: false
                }
                this.selectDataLimit(1, 1);
            }
        },
        selectDataLimit(dataLimitId, dataLimit) {
            this.template.dataLimitId = dataLimitId
            this.priceRatePlan.dataLimit = dataLimit
            this.checkPriceForRatePlan();
        },
        setDataGuardValidationPassed() {
            this.dgoPassed = true
        },
        createPlan: function(event) {

            let validationCounter = 0;

            this.planNameError = ''
            this.planNamePassed = false
            this.selectedPlanPassed = false
            this.planCategoryError = ''
            this.planDescriptionError = ''
            this.planDescriptionPassed = false
            this.planDataLimitError = ''
            this.dgoPassed = false
            this.dataLimitPassed = false
            this.throttleError = ''
            this.capError = ''
            this.alert1Error = ''
            this.alert2Error = ''

            if (this.prePaidAccount == true && this.noCreditCards == true) {
                let tempThis = this;

                setTimeout(function () {
                    tempThis.card.mount(document.querySelector("#card"))
                }, 100);
                this.$refs['add-credit-card'].show();
                return false;
            }

            if (this.template.planName == null || this.template.planName == '') {
                this.planNameError = 'The plan name field is required'
                validationCounter++;
            } else {
                this.planNamePassed = true
            }

            if (this.selectedPlan) {
                this.selectedPlanPassed = true;
                if (this.selectedPlan != 1) {
                    this.template.planCategoryId = this.selectedPlan;
                } else {
                    if (this.templateOptions.hotSpot) {
                        this.template.planCategoryId = 11
                    } else {
                        this.template.planCategoryId = this.selectedPlan;
                    }
                }
            } else {
                this.planCategoryError = 'Please Select a Rate Plan Category'
                validationCounter++;
            }

            if (this.template.planDescription == null || this.template.planDescription == '') {
                this.planDescriptionError = 'Please Input Plan Description'
                validationCounter++;
            } else {
                this.planDescriptionPassed = true
            }

            let dataLimitsIds = [0,1,2,4,5,6,7,8,9,10,11,12,13,14,15,16,17]
            if (dataLimitsIds.indexOf(this.template.dataLimitId) > -1) {
                this.dataLimitPassed = true
            } else {
                this.planDataLimitError = 'Data Tier Rate Plan is required to selected.'
                validationCounter++;
            }

            if (this.dataGuard.throttle.status) {
                if (this.dataGuard.throttle.data == '' || this.dataGuard.throttle.data == null || this.dataGuard.throttle.dataUnit == '' || this.dataGuard.throttle.dataUnit == null) {
                    this.throttleError = 'Please Provide a Value for Throttle'
                    validationCounter++;
                } else if (this.dataGuard.throttle.speed == '' || this.dataGuard.throttle.speed == null) {
                    this.throttleError = 'Please Provide a speed value for Throttle'
                    validationCounter++;
                }
            }

            if (this.dataGuard.cap.status) {
                if (this.dataGuard.cap.data == null ||  this.dataGuard.cap.data == '' || this.dataGuard.cap.dataUnit == null || this.dataGuard.cap.dataUnit == '') {
                    this.capError = 'Please Provide a Value for Data Cap'
                    validationCounter++;
                }
            }

            if (this.firstAlert) {
                if (this.dataGuard.firstUsageAlert.alertAt == null ||  this.dataGuard.firstUsageAlert.alertAt == '' || this.dataGuard.firstUsageAlert.alertAt == 0 || this.dataGuard.firstUsageAlert.unit == null || this.dataGuard.firstUsageAlert.unit == '') {
                    this.alert1Error = 'Please Provide a Value for Data Guard 1'
                    validationCounter++;
                }
            }

            if (this.secondAlert) {
                if (this.dataGuard.secondUsageAlert.alertAt == null ||  this.dataGuard.secondUsageAlert.alertAt == '' || this.dataGuard.secondUsageAlert.alertAt == 0 || this.dataGuard.secondUsageAlert.unit == null || this.dataGuard.secondUsageAlert.unit == '') {
                    this.alert2Error = 'Please Provide a Value for Data Guard 2'
                    validationCounter++;
                }
            }

            let dgoValues = [];

            if (this.dataGuard.throttle.status) {
                if (this.dataGuard.throttle.dataUnit == 'GB') {
                    dgoValues.push(this.dataGuard.throttle.data * 1024)
                } else {
                    dgoValues.push(Number(this.dataGuard.throttle.data))
                }
            } else {
                dgoValues.push(null);
            }

            if (this.dataGuard.cap.status) {
                if (this.dataGuard.cap.dataUnit == 'GB') {
                    dgoValues.push(this.dataGuard.cap.data * 1024)
                } else {
                    dgoValues.push(Number(this.dataGuard.cap.data))
                }
            } else {
                dgoValues.push(null);
            }

            if (this.firstAlert) {
                if (this.dataGuard.firstUsageAlert.unit == 'GB') {
                    dgoValues.push(this.dataGuard.firstUsageAlert.alertAt * 1024)
                } else {
                    dgoValues.push(Number(this.dataGuard.firstUsageAlert.alertAt))
                }
            } else {
                dgoValues.push(null);
            }

            if (this.secondAlert) {
                if (this.dataGuard.secondUsageAlert.unit == 'GB') {
                    dgoValues.push(this.dataGuard.secondUsageAlert.alertAt * 1024)
                } else {
                    dgoValues.push(Number(this.dataGuard.secondUsageAlert.alertAt))
                }
            } else {
                dgoValues.push(null);
            }

            if (this.dataGuard.throttle.status) {
                if (dgoValues[0] == dgoValues[1] && dgoValues[1] != null) {
                    this.throttleError = 'Throttle value can not be equal Cap value';
                    this.capError = 'Cap value can not be equal Throttle value';
                    validationCounter++;
                }
                if (dgoValues[0] == dgoValues[2] && dgoValues[2] != null) {
                    this.throttleError = 'Throttle value can not be equal Alert 1 value';
                    this.alert1Error = 'Alert 1 value can not be equal Throttle value';
                    validationCounter++;
                }
                if (dgoValues[0] == dgoValues[3] && dgoValues[3] != null) {
                    this.throttleError = 'Throttle value can not be equal Alert 2 value';
                    this.alert2Error = 'Alert 2 value can not be equal Throttle value';
                    validationCounter++;
                }
                if (dgoValues[0] > 100000 && this.dataGuard.throttle.dataUnit == 'MB') {
                    this.throttleError = 'Throttle value must be lower than 100000 MB';
                    validationCounter++;
                }
            }
            if (this.dataGuard.cap.status) {
                if (dgoValues[1] == dgoValues[2] && dgoValues[2] != null) {
                    this.capError = 'Cap value can not be equal Alert 1 value';
                    this.alert1Error = 'Alert 1 value can not be equal Cap value';
                    validationCounter++;
                }
                if (dgoValues[1] == dgoValues[3] && dgoValues[3] != null) {
                    this.capError = 'Cap value can not be equal Alert 2 value';
                    this.alert2Error = 'Alert 2 value can not be equal Cap value';
                    validationCounter++;
                }
                if (dgoValues[1] < dgoValues[0]) {
                    this.capError = 'Cap value must be higher than Throttle value.'
                    this.throttleError = 'Throttle value must be lower than Cap value.'
                    validationCounter++;
                }
                if (dgoValues[1] < dgoValues[2]) {
                    this.capError = 'Cap value must be higher than Alert 1 value.'
                    this.alert1Error = 'Alert 1 value must be lower than Cap value.'
                    validationCounter++;
                }
                if (dgoValues[1] < dgoValues[3]) {
                    this.capError = 'Cap value must be higher than Alert 2 value.'
                    this.alert2Error = 'Alert 2 value must be lower than Cap value.'
                    validationCounter++;
                }
                if (dgoValues[1] > 100000 && this.dataGuard.cap.dataUnit == 'MB') {
                    this.throttleError = 'Cap value must be lower than 100000 MB';
                    validationCounter++;
                }
            }
            if (this.firstAlert) {
                if (dgoValues[2] == dgoValues[3] && dgoValues[3] != null) {
                    this.alert1Error = 'Alert 1 value can not be equal Alert 2 value';
                    this.alert2Error = 'Alert 2 value can not be equal Alert 1 value';
                    validationCounter++;
                }
                if (dgoValues[2] > 100000 && this.dataGuard.firstUsageAlert.unit == 'MB') {
                    this.alert1Error = 'Alert 1 value must be lower than 100000 MB';
                    validationCounter++;
                }
            }
            if (this.secondAlert) {
                if (dgoValues[3] > 100000 && this.dataGuard.secondUsageAlert.unit == 'MB') {
                    this.throttleError = 'Alert 2 value must be lower than 100000 MB';
                    validationCounter++;
                }
            }

            if (this.throttleError == '' && this.capError == '' && this.alert1Error == '' && this.alert2Error == '') {
                this.setDataGuardValidationPassed();
            }

            if (validationCounter) {
                setTimeout(function () {
                    window.scroll(0, document.querySelector(".validation-false").offsetTop);
                }, 100);
                return false
            }

            this.templateOptionsArr = [];

            this.templateOptionsArr.push(2);

            if (this.templateOptions.roaming == true) {
                this.templateOptionsArr.push(1);
            }

            if (this.templateOptions.roaming2 == true) {
                this.templateOptionsArr.push(12);
            }

            if (this.templateOptions.sms == true) {
                this.templateOptionsArr.push(3);
            }

            if (this.templateOptions.staticip == true) {
                this.templateOptionsArr.push(16);
            }

            if (this.templateOptions.voice == true) {
                this.templateOptionsArr.push(4);
            }

            if (this.templateOptionsArr.length) {
                this.template.planOptionIds = this.templateOptionsArr;
            }

            if (this.dataGuard.throttle.status == true) {
                this.template.dataGuard.hasThrottle = 1;

                if (this.dataGuard.throttle.data != null) {
                    this.template.dataGuard.throttleAt = Number(this.dataGuard.throttle.data);
                    this.template.dataGuard.throttleAtUnit = this.dataGuard.throttle.dataUnit;
                }

                if (this.dataGuard.throttle.speed != null) {
                    this.template.dataGuard.throttleSpeedId = this.dataGuard.throttle.speed
                }
            } else {
                this.template.dataGuard.hasThrottle = 0;
            }

            if (this.dataGuard.cap.status == true) {
                this.template.dataGuard.hasCap = 1;

                if (this.dataGuard.cap.data != null) {
                    this.template.dataGuard.capAt = Number(
                        this.dataGuard.cap.data
                    );
                    this.template.dataGuard.capAtUnit = this.dataGuard.cap.dataUnit;
                }
            } else {
                this.template.dataGuard.hasCap = 0;
            }

            if (this.template.dataGuard.hasThrottle == 0) {
                this.template.dataGuard.hasThrottle = 0;
                delete this.template.dataGuard.throttleAt;
                delete this.template.dataGuard.throttleAtUnit;
                delete this.template.dataGuard.throttleSpeedId;
            }

            if (this.template.dataGuard.hasCap == 0) {
                this.template.dataGuard.hasCap = 0;
                delete this.template.dataGuard.capAt;
                delete this.template.dataGuard.capAtUnit;
            }

            if (this.template.planOptionIds && this.template.planOptionIds.length == 0) {
                delete this.template.planOptionIds;
            }

            if (this.firstAlert) {
                this.template.firstUsageAlert = {
                    alertAt: this.dataGuard.firstUsageAlert.alertAt,
                    unit: this.dataGuard.firstUsageAlert.unit
                }
            }

            if (this.secondAlert) {
                this.template.secondUsageAlert = {
                    alertAt: this.dataGuard.secondUsageAlert.alertAt,
                    unit: this.dataGuard.secondUsageAlert.unit
                }
            }

            var vjs = this;

            Axios.post(
                globalStore.data.restApiUrl + "/account/rate-plans",
                this.template
            ).then(function(response) {
                if (response.status == 200) {
                    if (window.routeFrom == 'activate') {

                        window.planAdded = response.data.response[0]['ratePlanId']
                        vjs.$router.push({
                            path: "/sim/active"
                        });
                    } else {
                        vjs.$router.push({
                            path: "/settings/plans",
                            query: { message: "true" }
                        });
                    }
                }
            }).catch(function(erorr) {
                var errors = erorr.response.data.errors;

                errors.map(error => {
                    vjs.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Create new Rate Plan',
                        text: error.errorMessage,
                        duration: 5000,
                    });

                })
            });
        }
    },
    mounted() {
        if (this.$cookies.get('nbIoTPlans') == 'true') {
            this.nbIoTAvailable = true
        } else if (this.$session.get('nbIoTPlans') == true) {
            this.nbIoTAvailable = true
        } else {
            this.nbIoTAvailable = false
            this.selectPlan(1);
        }
        if (this.$cookies.get('catM1Plans') == 'true') {
            this.catM1Available = true
        } else if (this.$session.get('catM1Plans') == true) {
            this.catM1Available = true
        } else {
            this.catM1Available = false
            this.selectPlan(1);
        }
    },
    created() {
        this.initStripe();

        if (this.$cookies.get('typeAccount') == 'PREPAID') {
            this.prePaidAccount = true;
            this.getCreditCards();
        }

        if (this.$cookies.get('tier2Roaming') == 'true' || this.$session.get('tier2Roaming')) {
            this.tier2Roaming = true;
        }

        if (this.$cookies.get('voiceAccess') == 'true' || this.$session.get('voiceAccess')) {
            this.voiceAccess = true;
        }

        if (this.$cookies.get('hotSpotAccess') == 'true' || this.$session.get('hotSpotAccess')) {
            this.hotSpotAccess = true;
        }
    }
};
</script>

<style lang="scss">
.flex {
    .hb-data,
    .nb-data {
        display: none;
        &.flex-data {
            display: inline-block;
            &#rate-plan-dataGuard {
                display: block;
            }
        }
    }
}

.high-bandwidth {
    .flex-data,
    .nb-data {
        display: none;
        &.hb-data {
            display: inline-block;
            &#rate-plan-dataGuard {
                display: block;
            }
        }
    }
}

.nb-iot {
    .flex-data,
    .hb-data {
        display: none;
        &.nb-data {
            display: inline-block;
            &#rate-plan-dataGuard {
                display: block;
            }
        }
    }
}



.select-plan {
    .card-header {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        div {
            line-height: 35px;
        }
        i {
            width: 18px;
            height: 18px;
            -webkit-border-radius: 100%;
            -moz-border-radius: 100%;
            border-radius: 100%;
            border: 2px solid #000000;
            line-height: 13px;
            &::before {
                font-size: 11px;
                line-height: 13px;
            }
        }
    }
}

.data-limit {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .button-data {
        width: 10%;
        max-width: 91px;
        height: 45px;
        line-height: 40px;
        margin-right: .5%;
        margin-bottom: .5%;
        background-color: transparent;
        border: 1px solid #c9cfd4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-size: 14px;
        text-transform: uppercase;
        &.hidden {
            display: none;
        }

        &[data-limit-id="0"] {
            text-transform: none;
            white-space: nowrap;
        }

        &:hover {
            background-color: #55cd6c !important;
            border-color: #55cd6c !important;
            color: #fff;
        }
        &.active {
            background-color: #0088ff !important;
            border-color: #0088ff !important;
            color: #fff;
            outline: none;
        }
    }
}

@media screen and (max-width: 1600px) {
    .data-limit .button-data {
        width: 15%;
        margin-right: 1% !important;
        &:nth-child(6n) {
            margin-right: 0;
        }
    }
}

.switch-label {
    //margin-bottom: 20px;
    label {
        vertical-align: middle;
        margin: 0;
        + label {
            margin-left: 10px;
        }
    }
    .mx-1 {
        float: right;
    }
}

.wrapper-plan {
    display: flex;
    justify-content: flex-start;

    .plan {
        position: relative;
        padding: 20px 80px;
        margin-right: 20px;
        max-width: 360px;

        border: 1px solid #c9cfd4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        text-align: center;

        -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

        cursor: pointer;

        &.plan-flex {
            &:hover {
                background-color: #abe390;
            }
        }
        &.plan-nb {
            &:hover {
                background-color: #8ac8ff;
            }
        }
        &.cat-m1 {
            &:hover {
                background-color: #ffc400;
            }
        }

        &.active {
            border-color: #0088ff;
            -webkit-box-shadow: 0px 0px 0px 1px #0088ff;
            box-shadow: 0px 0px 0px 1px #0088ff;

            .selected {
                display: block;
            }

            &.plan-flex {
                background-color: #abe390;
            }
            &.plan-nb {
                background-color: #8ac8ff;
            }
            &.cat-m1 {
                background-color: #ffc400;
            }
        }

        .selected {
            display: none;
            position: absolute;
            right: 0;
            top: 0;
            height: 29px;
            line-height: 29px;
            padding: 0 20px;
            background-color: #55cd6c;
            font-size: 14px;
            font-weight: 700;
            line-height: 29px;
            color: #fff;
            border-bottom-left-radius: 5px;
        }

        .name-plan {
            display: block;
            margin-bottom: 20px;

            font-size: 14px;
            text-transform: uppercase;
        }

        h3 {
            margin: 20px 0;
            font-size: 28px;
            line-height: 37px;
            font-family: "Arial", "Helvetica", sans-serif;
            font-weight: 700;
            white-space: nowrap;
        }

        .desc {
            display: block;
            margin-bottom: 20px;

            text-align: center;
        }

        .innerplan {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
        }
    }
}

.data-guard {
    .card-body {
        padding-bottom: 0;
        .inner-row {
            display: flex;
            margin: 0;
            .dgo-box {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                padding: 20px;
                margin-right: 20px;
                margin-bottom: 20px;
                border: 1px solid #c8ced3;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                &.active {
                    border-color: #0088ff;
                }
                &.error {
                    border-color: #fc4d4d;
                }
                &:last-child {
                    margin-right: 0;
                }
                .data-innerbox {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    .header {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 10px;
                        h3 {
                            display: inline-block;
                            vertical-align: top;
                            margin: 0;
                            margin-top: 4px;

                            font-size: 15px;
                            font-weight: 700;
                        }

                        label {
                            float: right;
                        }
                        .row-throttle,
                        .row-speed,
                        .row-alert {
                            width: 100%;
                            align-items: center;
                            margin-bottom: 20px;

                            .value {
                                display: inline-block;
                                vertical-align: top;

                                .form-control {
                                    max-width: 100px;
                                    display: inline-block;
                                    width: auto;
                                }
                            }

                            .label {
                                width: 100px;
                            }
                        }
                    }
                    .inner {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        flex-grow: 1;

                        .row-speed {
                            margin-bottom: 30px;
                        }

                        .recive-alerts-box {
                            h6 {
                                margin-bottom: 10px;
                                font-weight: 400;
                            }
                            .recive-alerts-btns {
                                display: flex;
                                .recive-alerts-btn {
                                    display: flex;
                                    align-items: center;
                                    flex-wrap: nowrap;
                                    padding: 8px 16px;
                                    margin-right: 10px;
                                    margin-bottom: 0;
                                    color: #000000;
                                    border: 1px solid #C9CFD4;
                                    -webkit-border-radius: 10px;
                                    -moz-border-radius: 10px;
                                    border-radius: 20px;
                                    cursor: pointer;

                                    &:last-child {
                                        margin-right: 0;
                                    }

                                    &.active {
                                        border-color: #0088ff;
                                        background-color: #0088ff;
                                        color: #ffffff;
                                    }

                                    i {
                                        margin-right: 8px;
                                    }

                                    span {
                                        white-space: nowrap;
                                    }

                                    input {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }

                .button-wrap .card-body {
                    justify-content: center;
                }
            }
            @media (max-width: 1800px) {
                .dgo-box {
                    min-width: calc(50% - 20px);
                    &:nth-child(odd) {
                        margin-right: 20px;
                    }
                    &:nth-child(even) {
                        margin-right: 0;
                    }
                    &:nth-child(n+2) {
                        .row-throttle {
                            margin-bottom: 96px;
                        }
                    }
                }
            }
        }
    }
}

#rate-plan-dataGuard {
    .card-body {
        .col-md-6 {
            margin-bottom: 30px;
        }
    }
}

.row-throttle,
.row-speed,
.row-alert {
    flex-direction: column;

    .switch-box {
        display: flex;
        justify-content: space-between;
        .label {
            display: block;
            margin-bottom: 6px;
        }
    }

    .value {
        max-width: 250px;
        margin-bottom: 10px;
        display: flex;
        .form-control {
            margin-top: 0;
        }
        input {
            width: 120px;
        }

        select {
            width: 30%;
            margin-left: 10px;
            min-width: 80px;
            &#speed-kbs {
                margin-left: 0;
                width: 100%;
            }
        }
    }
}
.alerts-and-notifications {
    margin-top: 30px;

    .alert-usage {
        .header {
            display: flex;
            justify-content: space-between;

            h3 {
                margin: 0;
                font-size: 15px;
                font-weight: 700;
            }
        }

        .value {
            max-width: 250px;
            display: flex;
            justify-content: space-between;

            input {
                width: 79%;
                &.error-visible {
                    border-color: #fc4d4d;
                }
            }

            select {
                width: 30%;
                margin: 0 0 0 10px;
                min-width: 80px;
            }
        }
        .error-message {
            display: block;
            visibility: hidden;
            color: #fc4d4d;
            margin-bottom: 10px;

            &.error-visible {
                visibility: visible;
            }
        }
    }

    .additional-notifications {
        .header {
            display: flex;
            justify-content: space-between;

            h3 {
                margin: 0;
                font-size: 15px;
                font-weight: 700;
            }
        }
    }
}

#rate-plan-name,
#rate-plan-category,
#rate-plan-description,
#rate-plan-dataLimit {
    .card-body {
        position: relative;
        .error-box {
            position: absolute;
            bottom: -20px;
            left: 5px;
            color: red;
        }
    }
}
.throttle-box,
.cap-box,
.alert1-box,
.alert2-box {
    position: relative;
    .error-box {
        position: absolute;
        bottom: -20px;
        left: 5px;
        color: red;
    }
}

.validate-warning {
    color: red;
}
.dark-theme {
    #add-credit-card {
        .modal-content {
            background-color: #3a4149;

            .user-details,
            h3 {
                color: #EDEEEF;
            }

            .modal-title,
            .close {
                color: #EDEEEF;
            }

            select,
            input {
                background-color: #2f353a;
                border-color: #171a1e;
                color: #EDEEEF;
                &::placeholder {
                    color: #EDEEEF;
                }
            }

            .StripeElement {
                background-color: #2f353a;
                border-color: #171a1e;
                .ElementsApp {
                    input {
                        color: #EDEEEF;
                    }
                }
            }
        }
    }
    .plan {
        border-color: #1a1c1d;
    }

    .data-limit {
        .button-data {
            border-color: #1a1c1d;
            color: #EDEEEF;
        }
    }
    .container-fluid {
        .create-plan-control {
            background-color: transparent;
            border-color: #2f353a;
            .card-body {
                background-color: transparent;
            }
        }
    }

    .popup-tooltip:hover {
        .popup-tooltip-content {
            background-color: #3a4149;
            border-color: #1a1c1d;
        }
    }

    .row-throttle,
    .row-speed,
    .row-cap {
        .value {
            input.form-control:disabled {
                background-color: #434B54;
            }
        }
    }
    .switch-slider {
        background-color: #3a4149;
    }

    .data-guard {
        .card-body {
            .inner-row {
                .dgo-box {
                    border-color: #1a1c1d;
                    .data-innerbox {
                        .inner {
                            .recive-alerts-box {
                                .recive-alerts-btns {
                                    .recive-alerts-btn {
                                        border-color: #1a1c1d;
                                        color: #ffffff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.header-data-guard {
    display: flex;
    justify-content: space-between;
    i {
        &:before {
            font-size: 18px;
        }
    }
}

.card-options {
    div.switch-label {
        margin-bottom: 20px;

        @media (min-width: 1200px) and (max-width: 1600px){
            &.col-md-6 {
                flex: 0 0 100%;
                max-width: 100%;
            }
        }
    }
}

.popup-tooltip {
    position: relative;

    .popup-tooltip-content {
        display: none;

        h3 {
            display: block;
            margin-bottom: 10px !important;
            font-size: 14px;
        }
        p {
           font-size: 14px;
            font-weight: 400;
        }
    }

    &:hover {
        .popup-tooltip-content {
            position: absolute;
            right: 2em;
            bottom: 100%;
            display: block;
            width: 400px;
            padding: 18px 20px 0 20px;
            margin-bottom: -1.5em;
            background: #ffffff;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 10px;
            -moz-border-radius: 10px;
            border-radius: 10px;
            z-index: 2048;
        }
    }
}

#create-template {
    .form-control {
        background-color: #F0F3F5;
        max-width: 800px;
    }

    .custom-checkbox {
        margin: 10px 0;
    }
}

.dark-theme {
    #create-template {
        .form-control {
            background-color: #515b65;
        }
    }
}

.price-wrapper {
    width: 540px;
    margin: 0 !important;
    > div {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #C9CFD4;

        span {
            font-size: 14px;

            small {
                font-size: 10px;
            }
        }
        em {
            font-weight: 700;
            font-style: normal;
            font-size: 15px;
        }
        &.start-price {
            em {

            }
        }
        &.user-discount {
            em {
                color: #FF6F00;
            }
        }
        &.final-price {
            em {
                font-size: 20px;
                color: #55CD6C;
            }
        }

        &.overage-price {
            flex-direction: column;
            padding-top: 0;
            border: 0;
            text-align: left;

            >span {
                font-size: 12px;
                line-height: 20px;
            }

            .price-wrapper {
                margin-top: 13px !important;
                padding: 10px 13px;
                background-color: #FDEBEB;

                .overage-price {
                    flex-direction: row;

                    em {
                        font-size: 14px;
                        line-height: 19px;
                        color: #2F353A;
                    }

                    &:last-child {
                        padding-bottom: 0;
                    }
                }
            }
        }
        &.final-price {
            border-bottom: 0;
            padding-bottom: 0;
        }
    }
}

    .dark-theme {
        .create-plan-summary {
            border: none !important;
            .price-wrapper {
                .start-price,
                .user-discount,
                .final-price {
                    border-color: #1a1c1d;
                }
            }
        }
    }

#add-credit-card {
    .required-cc {
        h3 {
            font-size: 14px;
            margin-bottom: 30px;
        }
    }
}

.StripeElement {
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 5px;
    background-color: #f0f3f5;
    border: 1px solid #C9CFD4;
}
</style>
